'use strict';

/**
 * CareerTeaser
 *
 * @author Matthias Giger <matthias.giger@namics.com>
 */
T.Module.CareerTeaser = T.createModule({

	_selectors: {
		imageWrapper: '[data-js-m-career-teaser__image]'
	},

	start: function start(resolve) {
		this.$ctx = $(this._ctx);

		this.$imageWrapper = this.$ctx.find(this._selectors.imageWrapper);

		this.$window = $(window);

		$(window).on('scroll', this.onScroll.bind(this));

		resolve();
	},
	onScroll: function onScroll() {
		var scrollTop = $(window).scrollTop();
		var windowHeight = this.$window.height();

		var newOffsetInPercentage = -(100 - scrollTop / windowHeight * 100);

		if (newOffsetInPercentage > 0) {
			newOffsetInPercentage = 0;
		}

		this.$imageWrapper.css('top', newOffsetInPercentage + '%');
	}
});